export function orderSystemAndOrganizationOptionGroups<T>(
    systemOptionGroups: T[],
    organizationOptionGroups: T[],
    systemFirst: boolean
): T[] {
    return systemFirst ? [
        ...systemOptionGroups,
        ...organizationOptionGroups
    ] : [
        ...organizationOptionGroups,
        ...systemOptionGroups
    ];
}

export function definedValues<T>(
    items: T[] | undefined,
    getValue: (item: T) => string | undefined | null
) {
    return items?.flatMap(item => {
        const value = getValue(item);

        return value !== undefined && value !== null ? [value] : [];
    }) ?? [];
}
